var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 11.6562V7.65625H8.34375V11.6562H9.65625ZM9.65625 14.3438V13H8.34375V14.3438H9.65625ZM4.28125 6.3125C5.59375 5 7.16667 4.34375 9 4.34375C10.8333 4.34375 12.3958 5 13.6875 6.3125C15 7.60417 15.6562 9.16667 15.6562 11C15.6562 12.8333 15 14.4062 13.6875 15.7188C12.3958 17.0104 10.8333 17.6562 9 17.6562C7.16667 17.6562 5.59375 17.0104 4.28125 15.7188C2.98958 14.4062 2.34375 12.8333 2.34375 11C2.34375 9.16667 2.98958 7.60417 4.28125 6.3125Z",
    fill: "#A81F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.3c5c5c2e41fbcd0863c789ac27b9c4cd.svg";
export { ForwardRef as ReactComponent };